export default "__VITE_ASSET__DaVIFCxS__"